// packages/shared/src/schemas/review.ts
import { z } from 'zod'

export const ReviewStatusEnum = z.enum(['pending', 'approved', 'rejected'])

export const ProductReviewSchema = z.object({
  id: z.string(),
  productId: z.string(),
  customerName: z.string(),
  rating: z.number().int().min(1).max(5),
  body: z.string(),
  status: ReviewStatusEnum,
  createdAt: z.string(),
})

export const CreateReviewInput = z.object({
  productId: z.string(),
  customerName: z.string().min(1).max(100).trim(),
  rating: z.coerce.number().int().min(1).max(5),
  body: z.string().min(10, 'Review must be at least 10 characters').max(1000).trim(),
})

export const UpdateReviewInput = CreateReviewInput.omit({ productId: true }).partial()

export type ProductReview = z.infer<typeof ProductReviewSchema>
export type CreateReviewInput = z.infer<typeof CreateReviewInput>
export type UpdateReviewInput = z.infer<typeof UpdateReviewInput>
